import React from 'react';
import { Link } from 'react-router-dom';

export const IntegrationSection = ({ payload }) => {
    return (
        <section>
            {
                payload.length != 0 && (
                    <div className="integration-section">
                        <div className="integration-title">{payload[0].title}</div>
                        <p className="integration-content">{payload[0].details}</p>
                        <div className="integration-image">
                            <img
                                src={payload[0].uploadedLogo.filePath}
                            />
                        </div>
                        <Link to="/signup" type="button" className="request-btn fs-28 bold hero-section-button integration-content-button">
                            <button className="txtblue innerBtn" id="reqdemo" >
                                Get a complete Demo
                            </button>
                        </Link>
                    </div>
                )
            }
        </section>
    )
}